module.exports = __webpack_public_path__ + "assets/img/lct3.365d4f07.png";